import { createReactOidc } from 'oidc-spa/react'
import { getBrandConfig } from '@/config/config'

const config = getBrandConfig()

export type DecodedIdToken = {
  sub: string
  aud: string
  exp: number
  family_name: string
  given_name: string
  name: string
  /**
   * Pam Account ID
   */
  'pam-aid': string
  /**
   * Pam Account Type
   */
  'pam-atype': 'STAFF' | 'PLAYER'
  preferred_username: string
  'pam-cap': boolean[]
  /**
   * Encoded Account Capabilities,
   * Use {@link decodeCapabilities} to get real values
   */
  'pam-cid': string
}
export const { OidcProvider, useOidc, getOidc } =
  createReactOidc<DecodedIdToken>({
    issuerUri: `${config.keycloak.url}/${config.keycloak.realm}/`,
    clientId: config.keycloak.clientId,
    homeUrl: import.meta.env.BASE_URL || '/',
    scopes: [], // "profile" is added by default, we don't want it because it has PII info so we override scopes"
  })
